// Surface B marginalia register — `EDITION I · LESSON N · BATCH M–N`. Replaces
// Surface A's frame counter at row 1; the batch range is en-dashed per
// typographic convention. Roman edition number locked at I per the spine §1;
// lesson number zero-padded to align tabular across the lesson sequence; the
// batch range itself is integer-only because real-kanji frames are integers
// (primitives carry decimal frame numbers and don't form batches per §11.6).
export function formatLessonNumber(n: number): string {
    return String(n).padStart(2, '0')
}

export function formatBatchRange(start: number, end: number): string {
    return `BATCH ${start}–${end}`
}

export function formatBatchMarginalia(
    lessonNumber: number,
    start: number,
    end: number
): string {
    return `EDITION I · LESSON ${formatLessonNumber(lessonNumber)} · ${formatBatchRange(start, end)}`
}
